import React, { useState, useEffect, useCallback } from 'react'

import {
	Button,
	Checkbox,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	FormControl,
	FormHelperText,
	InputAdornment,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	Snackbar,
	TextField,
	Typography
} from '@material-ui/core'
import { debounce } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useSelector, useDispatch } from 'react-redux'

import { DeletableChip } from '../../components/Misc/DeletableChip'

import { CustomAddOnOccurences } from '../Addons/customAddonOccurences'

import MuiAlert from '@material-ui/lab/Alert'

import { postAddOns } from '../../actions/addons/addons.actions'

const useStyles = makeStyles((theme) => ({
	dialog: {
		'& .MuiDialog-paper': {
			maxWidth: '920px',
			minWidth: '700px'
		}
	},
	formWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		margin: '24px 0px',
		'& .MuiTextField-root': {
			minWidth: '274px !important'
		},
		'& .MuiFilledInput-underline': {
			minWidth: '274px !important'
		}
	},
	fieldWrapper: {
		'&:nth-child(odd)': {
			marginRight: '25px'
		},
		display: 'flex',
		flexDirection: 'column',
		marginBottom: '20px'
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
		marginTop: '6px',
		backgroundColor: 'transparent !important'
	},
	chip: {
		marginRight: 2
	},
	currencyAdornment: {
		marginLeft: '10px',
		marginTop: '7px !important'
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	datePicker: {
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		}
	}
}))



const KennelBlockDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [mapped_areas, setMappedAreas] = useState([])
	const { isShown, setIsShown, kennelBlock, updateBlock, save, areas, kennels, setDelete } = props

	const isDisabled = () => {
		if (!kennelBlock || !kennelBlock.name || !kennelBlock.area_ids || !kennelBlock.area_ids.length || !kennelBlock.status || kennelBlock?.name?.length > 20) return true;
		return false;
	}

	return (
		<Dialog
			open={isShown}
			width="md"
			onClose={() => setIsShown()}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}>
			<DialogTitle>{kennelBlock?._id ? 'Edit Kennel Block' : 'Add New Kennel Block'}</DialogTitle>
			<DialogContent>
				<div className={classes.formWrapper}>

					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Name"
							value={kennelBlock.name}
							style={{ width: '48%', marginBottom: 16 }}
							helperText={`${kennelBlock.name ? kennelBlock.name.length : '0'} / 20 max characters`}
							error={kennelBlock?.name?.length > 20}
							required
							onChange={(e) => updateBlock('name', e.target.value)}
							variant="filled"
						/>
						<Autocomplete
							multiple
							disableCloseOnSelect
							size="small"
							id="breed"
							style={{ width: '48%' }}
							className={classes.autoComplete}
							options={areas}
							value={(kennelBlock?.area_ids || []).map(id => areas.find(a => a._id === id))}
							onChange={(e, v) => {
								updateBlock('area_ids', v.map(a => a._id))
							}}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderTags={(selected) =>
								selected.filter(Boolean).map(value => {
									return (
										<DeletableChip
											key={value._id}
											label={value.name}
											style={{ textTransform: 'uppercase' }}
											{...{
												onDelete: () => {
													let ids = selected.filter(s => s._id !== value._id).map(a => a._id)
													updateBlock('area_ids', ids)
												}
											}}
										/>
									)
								})
							}
							getOptionLabel={(option) => option.name}
							renderOption={(option, { selected }) => {
								let isSelected = kennelBlock?.area_ids?.includes(option._id)
								return (
									<React.Fragment>
										<Checkbox checked={isSelected} />
										<ListItemText style={{ textTransform: 'capitalize' }} primary={option.name} />
									</React.Fragment>
								)
							}}
							renderInput={(params) => (
								<TextField {...params} variant="filled" required fullWidth label="Areas" />
							)} />
					</div>
					<div
						style={{
							display: 'flex',
							width: '100%',
							flexDirection: 'row',
							justifyContent: 'space-between'
						}}>
						<TextField
							label="Count"
							value={kennels && kennelBlock._id ? kennels.filter(k => k.kennel_block_id === kennelBlock._id).length : 0}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							disabled={true}
							variant="filled" />
						<TextField
							select
							label="Status"
							required
							value={kennelBlock.status}
							style={{ width: '48%', marginBottom: 16, textTransform: 'capitalize' }}
							onChange={(e) => updateBlock('status', e.target.value)}
							variant="filled">
							{['active', 'disabled'].map(s => (
								<MenuItem value={s} style={{ textTransform: 'capitalize' }}>{s}</MenuItem>
							))}
						</TextField>
					</div>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" onClick={save} color="secondary" disabled={isDisabled()}>
					SAVE
				</Button>
				<Button variant="outlined" onClick={() => setIsShown()} color="secondary">
					CANCEL
				</Button>
				{kennelBlock?._id &&
					<Button variant="text"
						onClick={() => {
							setDelete('kennel block')
						}}
						style={{
							fontFamily: 'Nunito',
							color: '#D02C2C',
							fontSize: '14px',
							lineHeight: '19px',
							marginLeft: 'auto',
							textTransform: 'uppercase',
							fontWeight: '800'
						}}>
						Delete Kennel Block
					</Button>
				}
			</DialogActions>
		</Dialog>
	)
}

export default KennelBlockDialog
